import { withSearch } from '@elastic/react-search-ui';
import DropDownFacetFilters from '../../../components/filter/DropDownFacetFilter';

function HeritageGatewayLocalAuthorityFilter({
  setFilter,
  removeFilter,
  facets,
  filters,
}) {
  return (
    <DropDownFacetFilters
      facets={facets}
      fieldId="district"
      filters={filters}
      formHint="Includes county councils, unitary authorities, London boroughs and all districts"
      id="district"
      label="Local authority"
      removeFilter={removeFilter}
      setFilter={setFilter}
      sort={true}
    />
  );
}

export default withSearch(({ setFilter, removeFilter, facets, filters }) => ({
  setFilter,
  removeFilter,
  facets,
  filters,
}))(HeritageGatewayLocalAuthorityFilter);
